import { helpCenterFaqGroups, helpCenterFaqsIntro } from "../data/helpCenterFaqs";
import FaqAccordionItem from "../components/FaqAccordionItem";

const HelpCenterFaqs = () => (
	<div className="help-center__content-block">
		<p className="help-center__page-intro fs-13 ff-light">
			{helpCenterFaqsIntro}
		</p>
		{helpCenterFaqGroups.map((group) => (
			<section key={group.id} className="help-center__subsection">
				<h3 className="help-center__subsection-title ff-medium fs-14">
					{group.title}
				</h3>
				{group.items.map((item, index) => (
					<FaqAccordionItem
						key={`${group.id}-${index}`}
						question={item.question}
						answer={item.answer}
					/>
				))}
			</section>
		))}
	</div>
);

export default HelpCenterFaqs;
